module.exports = __webpack_public_path__ + "static/media/sharing_first_walk.40041423.jpg";